import { render, staticRenderFns } from "./session.vue?vue&type=template&id=3b22e444"
import script from "./session.vue?vue&type=script&lang=js"
export * from "./session.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports